module.exports = __webpack_public_path__ + "img/gift-ui-04.323c3954.png";